import classNames from 'classnames';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { Breakpoint, IconHeadsetSrc, Image, useBreakpoint } from '@jsmdg/yoshi';
import BallonIcon from '@jsmdg/yoshi/dist/components/Icons/svg/ballon.svg';
import HalfClockIcon from '@jsmdg/yoshi/dist/components/Icons/svg/halfClock.svg';
import { type ProductDetailContext } from '../../types/types';
import styles from './BuyboxSeal.module.scss';

const BuyBoxSeal = (): JSX.Element => {
    const upToSMBreakpoint = useBreakpoint(Breakpoint.SM);
    const { tenantConfig } = useFragmentContext<ProductDetailContext>();

    return (
        <>
            {upToSMBreakpoint && (
                <div
                    className={classNames(
                        styles.uspWrapper,
                        'd-flex flex-md-row flex-column px-6x',
                    )}
                >
                    <div className="d-flex flex-column py-3x">
                        <div
                            className={classNames(
                                styles.uspText,
                                'd-flex align-items-center mb-2x',
                            )}
                        >
                            <Image
                                className={`${styles.icons} mr-0-5x`}
                                src={BallonIcon}
                                alt=""
                                lazyLoad={false}
                                width={20}
                                height={20}
                                fetchpriority="low"
                            />

                            <span>{tenantConfig.uspPrimaryText}</span>
                        </div>

                        <div
                            className={classNames(
                                styles.uspText,
                                'd-flex align-items-center mb-2x',
                            )}
                        >
                            <Image
                                className={`${styles.icons} mr-0-5x`}
                                src={HalfClockIcon}
                                alt=""
                                lazyLoad={false}
                                width={20}
                                height={20}
                                fetchpriority="low"
                            />

                            <span>{tenantConfig.uspSecondaryText}</span>
                        </div>

                        <div className={classNames(styles.uspText, 'd-flex align-items-center')}>
                            <Image
                                className={`${styles.icons} mr-0-5x`}
                                src={IconHeadsetSrc}
                                alt=""
                                lazyLoad={false}
                                width={20}
                                height={20}
                                fetchpriority="low"
                            />
                            <span>{tenantConfig.uspTertiaryText}</span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export { BuyBoxSeal };
